// extracted by mini-css-extract-plugin
module.exports = {"sidebarHideTransition":"menubar_sidebarHideTransition__G51UI","slideInFromLeft":"menubar_slideInFromLeft__RnY8v"};